import { render, staticRenderFns } from "./ComponentListTemplate.vue?vue&type=template&id=50c6c405&scoped=true&"
import script from "./ComponentListTemplate.vue?vue&type=script&lang=js&"
export * from "./ComponentListTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ComponentListTemplate.vue?vue&type=style&index=0&id=50c6c405&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6c405",
  null
  
)

export default component.exports